import view from '../../../view';
import { connectedStore } from '../../../store';
import { DISABLE_BLUR_ATTR } from '../../constants/attributes';

const unselectElementOnParentContextClick = (event) => {
  if (!event.view) {
    return;
  }

  const store = connectedStore.get();
  const state = store.getState();

  const selectedElementId = view.selectors.getSelectedElement(state);

  if (!selectedElementId) {
    return;
  }

  const { target } = event;
  const disableBlurElement = target.closest(`[${DISABLE_BLUR_ATTR}]`);
  if (disableBlurElement) return;

  store.dispatch(view.actions.setSelectedElement(null));
};

export default unselectElementOnParentContextClick;
